import { render, staticRenderFns } from "./MessagesDialog.vue?vue&type=template&id=7f6d83bb&scoped=true"
import script from "./MessagesDialog.vue?vue&type=script&lang=js"
export * from "./MessagesDialog.vue?vue&type=script&lang=js"
import style0 from "./MessagesDialog.vue?vue&type=style&index=0&id=7f6d83bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d83bb",
  null
  
)

export default component.exports